const Config = {
  auth: {
    identityPoolId: 'us-east-1:00f8636a-7d5e-45e0-a0b4-252114db74a9',
    region: 'us-east-1',
    userPoolId: 'us-east-1_q9uuYONw2',
    userPoolWebClientId: '3ppn49ujrp8j79ge4fjluh0ops',
    mandatorySignIn: false,
    authenticationFlowType: 'USER_SRP_AUTH',
  },
  appsync: {
    graphqlEndpoint:
      'https://25au2xqglbfxxerigojrcgkeji.appsync-api.us-east-1.amazonaws.com/graphql',
    region: 'us-east-1',
    authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  },
};

export default Config;



// WEBPACK FOOTER //
// ./src/constants/Config.tsx